<template>
  <treeselect
    :default-expand-level="0"
    :value="mockValue ? mockValue : selectedJobTitlesAndFunctions"
    @input="mockValue || (selectedJobTitlesAndFunctions = $event)"
    v-model="selectedJobTitlesAndFunctions"
    :normalizer="addLabelToNode"
    :multiple="false"
    :options="options"
    :disabled="$props.disabled"
    :disable-branch-nodes="true"
    :required="$props.required"
    :valueFormat="returnType || 'id'"
    @select="handleSelect"
    @deselect="handleSelect"
    @search-change="generateTree"
  />
</template>
<script>
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { HapiService } from "@/core/services/hapi.service";

export default {
  name: "JobTitlesAndFunctions",
  props: [
    "value",
    "disabled",
    "mockValue",
    "initialOptions",
    "optionsSourceEndpoint",
    "initialOptionsType",
    "returnType",
    "nodeParser",
    "required",
    "changeValue"
  ],
  components: { Treeselect },
  asyncComputed: {},
  data() {
    return {
      jobFunctions: [],
      options: []
    };
  },
  methods: {
    async generateTree(searchQuery) {},
    handleSelect(node) {
      if (!this.$props.returnType || this.$props.returnType === "id")
        this.$emit("input", node.id);
      else if (this.$props.returnType === "node") this.$emit("input", node);
    },
    handleDeselect() {
      this.$emit("input", null);
    },
    addLabelToNode(node) {
      node["label"] = node["name"];
    },
    listToTree(items) {
      var tree = [],
        mappedArr = {};

      // Build a hash table and map items to objects
      items.forEach(function(item) {
        var id = item.id;

        if (!Object.prototype.hasOwnProperty.call(mappedArr, id)) {
          // in case of duplicates
          mappedArr[id] = item; // the extracted id as key, and the item as value
        }
      });

      // Loop over hash table
      for (var id in mappedArr) {
        if (Object.prototype.hasOwnProperty.call(mappedArr, id)) {
          let mappedElem = mappedArr[id];

          // If the element is not at the root level, add it to its parent array of children. Note this will continue till we have only root level elements left
          if (mappedElem.parent) {
            var parentid = mappedElem.parent;
            if (!mappedArr[parentid].children)
              mappedArr[parentid].children = mappedArr[parentid].children = [];
            mappedArr[parentid].children.push(mappedElem);
          }

          // If the element is at the root level, directly push to the tree
          else {
            tree.push(mappedElem);
          }
        }
      }

      return tree;
    },
    removeEmptyChildren(parentItem) {
      if (parentItem.children.length) {
        for (const item of parentItem.children) {
          this.removeEmptyChildren(item);
        }
      } else {
        delete parentItem.children;
      }
      return parentItem;
    },
    handleChange(node) {
      // console.log("===>", node);
    }
  },
  async mounted() {
    let jobFunctions = [];
    if (this.$props.optionsSourceEndpoint !== undefined) {
      const response = await HapiService.apiService.get(
        this.$props.optionsSourceEndpoint
      );

      jobFunctions = response.data;
      if (this.$props.initialOptionsType === "job-functions") {
        jobFunctions = response.data.map(item =>
          this.removeEmptyChildren(item)
        );
      }
    } else if (this.$props.initialOptions !== undefined) {
      jobFunctions = this.$props.initialOptions;
    } else {
      throw new Error(
        "Component expects either 'options' or 'optionsSourceEndpoint' properties to be non-null"
      );
    }
    // console.log("InitialOptions values: ", this.$props.initialOptions);
    this.options = jobFunctions;
    // console.log("initialOptionsType: ", this.$props.initialOptionsType);
    if (this.$props.initialOptionsType === "hierarchical") {
      this.options = this.listToTree(this.options);
      // console.log("Hierarchical options: ", this.options);
    }
  },
  watch: {
    itemText: "initItems"
  },
  computed: {
    selectedJobTitlesAndFunctions: {
      get() {
        return this.value?.id ? this.value : null;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>

<style scoped>
.vue-tags-input {
  /*min-width: 300px !important;*/
}
.ti-tag {
}
</style>
